import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'

const Header = () => {
    return (
        <div>

            <Navbar />
        </div >
    )
}

export default Header
